import { action, observable, makeObservable } from 'mobx';

class GameStore {
  isBetsClosed = false;

  isPigMultiplierInvisible = false;

  multiplierData = {};

  isFakeImagesLoaded = false;

  constructor() {
    makeObservable(this, {
      isBetsClosed: observable,
      isPigMultiplierInvisible: observable,
      multiplierData: observable.deep,
      isFakeImagesLoaded: observable,
      setIsBetsClosed: action.bound,
      setMultiplierData: action.bound,
      updateIsFakeImagesLoaded: action.bound,
    });
  }

  setIsBetsClosed(arg) {
    this.isBetsClosed = arg;
  }

  setIsPigMultiplierInvisible(arg) {
    this.isPigMultiplierInvisible = arg;
  }

  setMultiplierData(data) {
    this.multiplierData = data;
  }

  updateIsFakeImagesLoaded(fakeImagesLoadedCount, fakeImagesCount) {
    this.isFakeImagesLoaded = fakeImagesLoadedCount === fakeImagesCount;
  }
}

export const gameStore = new GameStore();
